var map = {
	"./ar-YE/core": [
		639,
		639
	],
	"./bg-BG/core": [
		6146,
		146
	],
	"./cs-CZ/core": [
		21,
		21
	],
	"./da-DK/core": [
		8073,
		73
	],
	"./de-DE/core": [
		3487,
		487
	],
	"./en-GB/core": [
		9372,
		372
	],
	"./en-US/core": [
		150
	],
	"./es-ES/core": [
		6534,
		534
	],
	"./fa-IR/core": [
		5618,
		618
	],
	"./fr-FR/core": [
		8718,
		718
	],
	"./hu-HU/core": [
		6034,
		34
	],
	"./id-ID/core": [
		7541,
		541
	],
	"./it-IT/core": [
		6902,
		902
	],
	"./ja-JP/core": [
		2703,
		703
	],
	"./ko-KR/core": [
		7267,
		648
	],
	"./nl-NL/core": [
		7444,
		444
	],
	"./pl-PL/core": [
		151,
		151
	],
	"./pt-BR/core": [
		3903,
		903
	],
	"./ro-RO/core": [
		2562,
		562
	],
	"./ru-RU/core": [
		8510,
		510
	],
	"./sk-SK/core": [
		3831,
		831
	],
	"./sr-Cyrl-CS/core": [
		225,
		225
	],
	"./sr-Latn-CS/core": [
		3683,
		683
	],
	"./sv-SE/core": [
		5938,
		938
	],
	"./tr-TR/core": [
		3083,
		83
	],
	"./uk-UA/core": [
		6958,
		958
	],
	"./uz-UZ/core": [
		9600,
		600
	],
	"./zh-CN/core": [
		5907,
		907
	],
	"./zh-TW/core": [
		8072,
		72
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(() => {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return Promise.all(ids.slice(1).map(__webpack_require__.e)).then(() => {
		return __webpack_require__(id);
	});
}
webpackAsyncContext.keys = () => (Object.keys(map));
webpackAsyncContext.id = 5165;
module.exports = webpackAsyncContext;